import Swiper from "swiper";

// Main Slider
var mainSlider = new Swiper(".js-scrollerMain", {
  slidesPerView: "auto",
  loop: true,
  speed: 1400,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  effect: "fade",
  fade: {
    crossFade: true,
  },
});
